import {
	Id,
	LaravelResponse,
	ModelUsageResource,
	keyToUrl,
	withDestroyEndpoint,
	withIndexEndpoint,
	withShowEndpoint,
	withStoreEndpoint,
	withUpdateEndpoint,
} from "@dgs/core";
import axios from "axios";
import {
	EventCategoryIndexResource,
	EventCategorySaveRequest,
	EventCategoryUpdateResource,
} from "../types/eventCategory";

const baseKey = ["event-categories"];

const showUsageKey = (eventCategoryId: Id) => [...eventCategoryService.showKey(eventCategoryId), "usage"];

export const eventCategoryService = {
	...withIndexEndpoint<EventCategoryIndexResource>(baseKey),
	...withShowEndpoint<EventCategoryUpdateResource>(baseKey),
	...withStoreEndpoint<EventCategorySaveRequest>(baseKey),
	...withUpdateEndpoint<EventCategorySaveRequest>(baseKey),
	...withDestroyEndpoint(baseKey),
	showUsageKey,
	showUsage: (eventCategoryId: Id) =>
		axios.get<LaravelResponse<ModelUsageResource[]>>(keyToUrl(showUsageKey(eventCategoryId))),
};
